
        Component.define('youbuy-comparar', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el   = $(el);
let image;

let selectedAirplane = JSON.parse(localStorage.getItem("model"));

let app = new Vue({
    el: '#app-comparar',
    delimiters: ['${', '}'],
    data: {
        selectedModel: '',
        models: null,
        airplanes: null,
    },
    methods: {
        comparar: function(id) {
            localStorage.setItem('model', id);
        },
        handleResize() {
            let airplanes = document.getElementsByClassName('airplane');
            $(airplanes).find('.compare-header').eqHeight(airplanes.length);
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
})

axios
    .get(root + 'wsyoubuy')
    .then(function(response) {
        let allAirplanes = response.data.airplanes;
        let allModels    = response.data.models;

        allModels = allModels.filter(function(model, index) {
            if (allAirplanes.find(o => o.model == model.id)) {
                return model;
            }
        });

        allAirplanes = allAirplanes.map(obj => {
            if (obj.images) {
                Object.assign(obj, {thumb: JSON.parse(obj.images)[0].image});
            }

            obj.model = (allModels.find(o => o.id == obj.model));

            return obj;
        });

        app.airplanes = allAirplanes.filter(function(airplane, index) {
            if (selectedAirplane.includes(airplane.id)) {
                return airplane;
            }
        });
    });

        });